<template>

  <div>
    <!-- <div v-html="agreement"></div> -->
    <userAgreementCn v-if="userAgreementCn"></userAgreementCn>
    <userAgreementTw v-if="userAgreementTw"></userAgreementTw>
    <userAgreementUs v-if="userAgreementUs"></userAgreementUs>
  </div>
</template>
<script>
  import userAgreementCn from "@/components/userAgreementCn.vue";
  import userAgreementTw from "@/components/userAgreementTw.vue";
  import userAgreementUs from "@/components/userAgreementUs.vue";
  export default {
    components: {
      userAgreementCn,
      userAgreementTw,
      userAgreementUs,
    },
    data() {
      return {
        agreement: '',
        userAgreementCn: false,
        userAgreementTw: false,
        userAgreementUs: false,
      }
    },
    mounted() {
      // this.$fetchql.japi("appapi/baseclientagreement/getinfo?agreementCode=H5YHXY").then((result) => {
      //   if (result.code == 200) {
      //     this.agreement = result.data.content
      //   }
      // });
      if (localStorage.getItem('lang') == 'zh-cn') {
        this.userAgreementCn = true;
      } else if (localStorage.getItem('lang') == 'zh-tw') {
        this.userAgreementTw = true;
      } else if (localStorage.getItem('lang') == 'en-us') {
        this.userAgreementUs = true;
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/userAgreement.vue